export class ResetReservation {
  static readonly type = '[Reservation] Reset Reservation';
}
